import {
  ArrowBack,
  ArrowDownward,
  ArrowForward,
  ArrowUpward,
} from "@mui/icons-material";
import { Box, Icon } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { keyframes } from "@mui/system";

const iconifyMove = (move: string, index: number) => {
  let iconSx;

  switch (index) {
    case 0:
      iconSx = {
        opacity: "100%",
        animation: `${fadeOut} 0.5s`,
        fontSize: 50,
        animationFillMode: "forwards",
      };
      break;
    case 1:
      iconSx = {
        border: "4px solid darkred",
        zIndex: 2,
        color: "darkred",
        fontSize: 50,
      };
      break;
    default:
      iconSx = { fontSize: 50 };
  }

  switch (move) {
    case "w":
      return <ArrowUpward key={`move-${index}-${move}`} sx={iconSx} />;
    case "a":
      return <ArrowBack key={`move-${index}-${move}`} sx={iconSx} />;
    case "s":
      return <ArrowDownward key={`move-${index}-${move}`} sx={iconSx} />;
    case "d":
      return <ArrowForward key={`move-${index}-${move}`} sx={iconSx} />;
    case " ":
      return <Icon key={`move-${index}-${move}`} sx={iconSx} />;
  }
};

const randomMove = (): string => {
  switch (Math.floor(Math.random() / 0.25)) {
    case 0:
      return "w";
    case 1:
      return "a";
    case 2:
      return "s";
    default:
      return "d";
  }
};

const randomMoveString = (length: number): string => {
  if (length === 1) {
    return randomMove();
  } else {
    return randomMove() + randomMoveString(length - 1);
  }
};

const shrink = keyframes`
  from {
    width: 100%
  }
  to {
    width: 0%
  }
`;

const shrink2 = keyframes`
  from {
    width: 50px
  }
  to {
    width: 0px
  }
`;

const fadeOut = keyframes`
0% {
  opacity: 1;
}
100% {
  opacity: 0;
}
`;

const MoveBar = ({ moves }: { moves: string }) => {
  return (
    <Box
      sx={{
        margin: "40px",
        borderTop: "2px solid white",
        borderBottom: "2px solid white",
        color: "white",
        display: "flex",
        width: "50%",
        height: "55px",
      }}
    >
      <Box
        sx={{
          minWidth: "50%",
          height: "100%",
        }}
      />
      <Box
        sx={{
          height: "100%",
          display: "inline-flex",
          flexWrap: "nowrap",
          overflow: "visible",
          left: "-75px",
          position: "relative",
        }}
      >
        {[
          moves[0] !== " " && (
            <Box
              key={`shrink-boi-${moves.length}`}
              sx={{
                animation: `${shrink2} 0.1s`,
                height: "100%",
                width: "0px",
                animationTimingFunction: "linear",
                display: "inline",
              }}
            />
          ),
          ...moves.split("").map(iconifyMove),
        ]}
      </Box>
    </Box>
  );
};

export const QTE = ({
  images,
  timeLimit,
  buttonCount,
  win,
  lose,
}: {
  images: string[];
  timeLimit: number;
  buttonCount: number;
  win: () => void;
  lose: () => void;
}) => {
  const [moves, setMoves] = useState(" " + randomMoveString(buttonCount));
  const timeLimitTask = useRef<NodeJS.Timeout>();

  if (moves.length === 1) {
    win();
  }

  useEffect(() => {
    timeLimitTask.current = setTimeout(lose, timeLimit * 1000);
    return () => clearTimeout(timeLimitTask.current);
  }, [win, lose, timeLimit, timeLimitTask]);

  const imageStep = buttonCount - (moves.length - 1);

  useEffect(() => {
    const buttonPress = (e: any) => {
      var key = "";

      switch (e.key) {
        case "w":
        case "ArrowUp":
          key = "w";
          break;
        case "a":
        case "ArrowLeft":
          key = "a";
          break;
        case "s":
        case "ArrowDown":
          key = "s";
          break;
        case "d":
        case "ArrowRight":
          key = "d";
      }

      console.log(key);

      if (moves[1] === key) {
        setMoves(moves.slice(1));
      } else {
        if (key) {
          lose();
        }
      }
    };

    document.addEventListener("keydown", buttonPress);

    return () => {
      document.removeEventListener("keydown", buttonPress);
    };
  }, [lose, moves]);

  const image = images[imageStep % images.length];

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${process.env.PUBLIC_URL}/bossfight/img/${image})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        flexDirection: "column",
      }}
    >
      <MoveBar moves={moves} />
      <Box
        sx={{
          width: "50%",
          backgroundColor: "lightgray",
          height: "10px",
          borderRadius: "5px",
          border: "solid 2px black",
        }}
      >
        <Box
          sx={{
            animation: `${shrink} ${timeLimit}s`,
            backgroundColor: "darkred",
            height: "10px",
            width: "0%",
            animationTimingFunction: "linear",
            borderRadius: "2px",
          }}
        />
      </Box>
    </Box>
  );
};
